/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Best_SellerInputs */

const vi_shop_best_seller = /** @type {(inputs: Shop_Best_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán chạy`)
};

/**

* @param {Shop_Best_SellerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_best_seller = /** @type {((inputs?: Shop_Best_SellerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Best_SellerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_best_seller(inputs)
});